<template>
	<div class="datefield" @keyup.capture="updateValue">
		<input 
			v-model="month" 
			ref="day"
			class="datefield__input datefield__input--month input is-small" 
			type="numeric" 
			placeholder="mm"
			@input="updateMonth"
			@blur="month = month.padStart(2, 0)"
			v-on:keyup.enter="$emit('enter')">
		<span class="datefield__divider">/</span>
		<input 
			v-model="day" 
			ref="numeric"
			class="datefield__input datefield__input--day input is-small" 
			type="number" 
			placeholder="dd"
			@input="updateDay"
			@blur="day = day.padStart(2, 0)"
			v-on:keyup.enter="$emit('enter')">
		<span class="datefield__divider">/</span>
		<input 
			v-model="year" 
			ref="numeric"
			class="datefield__input datefield__input--year input is-small" 
			type="number" 
			placeholder="yyyy"
			@blur="year = year.padStart(4, 0)"
			v-on:keyup.enter="$emit('enter')">
		<span class="icon is-small is-left">
		<i class="fa fa-calendar"></i>
		</span>
	</div>
</template>

<script>
	export default {
		name: "DateField",
		props: {
			value: {
				type: [Number, String],
				required: true,
			},
		},
		data() {
			return {
				day: `${new Date(parseInt(this.value)).getDate()}`,
				month: `${new Date(parseInt(this.value)).getMonth() + 1}`,
				year: `${new Date(parseInt(this.value)).getFullYear()}`,
			}
		},
		watch: {
			year(current) {
				const cYear = (new Date()).getFullYear()
				if (current > cYear) { this.year = cYear }
				else if (current > 1000 && current < 1900) { this.year = 1900 }
			}
		},
		methods: {
			updateDay() {
				if (!this.day.length || parseInt(this.day, 10) < 4) { return }
			},
			updateMonth() {
				if(!this.month.length || parseInt(this.month, 10) < 2) { return }
			},
			updateValue() {
				const timestamp = new Date(parseInt(this.year), parseInt(this.month-1), parseInt(this.day));
				if (Number.isNaN(timestamp)) return;

				this.$emit('input', timestamp);
			}
		}
	}
</script>

<style lang="scss">
	.datefield {
		$spacing: 0.75em;

		display: inline-flex;
		position: relative;
		overflow: hidden;
		border: 1px solid #888;
		border-radius: 0.25em;

		&__input {
			padding: $spacing;
			padding-right: $spacing / 2 !important;
			padding-left: $spacing / 2 !important;
			border: none;
			text-align: center;
			-moz-appearance: textfield; // 1

			&::-webkit-inner-spin-button {
				display: none; // 1
			}

			&:first-child {
				padding-left: $spacing !important;
			}

			&:last-child {
				padding-right: $spacing !important;
			}

			&:focus {
				outline: none;
			}

			&--day {
				width: 3em;
			}
			&--month {
				width: 4.25em;
				text-align: right;
				padding-right: 0.6em !important;
			}

			&--year {
				width: 4em;
			}

			&__divider {
				padding-top: $spacing;
				padding-bottom: $spacing;
				pointer-events: none;
			}
		}
	}
</style>